@if (!isSmallerScreen) {
  <div class="sidebar" [class.collapsed]="collapsed">
    <nav>
      @for(link of list; track link){
        @if (link.is_visible) {
          <a [routerLink]="link.path" routerLinkActive="active" class="menu-item"
            [matTooltip]="collapsed?link.name:''" matTooltipPosition="right">
            <img class="menu-icon" [src]="getIcon(link.name)" [alt]="link.name">
            @if (!collapsed) {
              <span>
                {{link.name}}
              </span>
            }
          </a>
        }
      }
    </nav>
  </div>
}
